import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { hasPermission } from '@features/rbac/permissions'
import { StaffRolesTab } from '@features/staff-roles/components/StaffRolesTab'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/staff/$initials/roles')({
    component: RouteComponent,
    beforeLoad: ({ params }) => {
        if (!hasPermission('roles.manage') || !hasPermission('permissions.manage')) {
            throw redirect({ to: '/unauthorised' })
        }
    }
})

function RouteComponent() {

    const { initials } = Route.useParams()

    return (
        <QueryErrorBoundary title='Failed to load roles'>
            <Suspense fallback={<LoadingIndicator resource='roles'/>}>
                <StaffRolesTab initials={initials} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
